<template>
  <div class="login">
    <div class="login-main">
      <img src="../assets/loginLogo.png" />
      <h1>{{ title }}</h1>
      <div class="select-box">
        <el-select
          @change="selectl"
          v-model="value1"
          placeholder="Select a Language "
        >
          <el-option
            v-for="item in options1"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>

        <el-select
          @change="selectr"
          v-model="value2"
          placeholder="Select a Region "
        >
          <el-option
            v-for="item in options2"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            :disabled="item.disabled"
          >
          </el-option>
        </el-select>

        <div class="subtn">
          <router-link to="/investor">Investor Section</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      title: "Lung Solutions, Better Life™",
      options1: [
        {
          value: "1",
          label: "English",
        },
        {
          value: "0",
          label: "简体中文",
        },
        {
          value: "6",
          label: "繁體中文",
        },
      ],
      options2: [
        {
          value: "0",
          label: "中国",
        },
        {
          value: "1",
          label: "Europe",
          // disabled:true
        },
        {
          value: "2",
          label: "North America",
          // disabled:true
        },
        {
          value: "3",
          label: "Worldwide",
        },
      ],
      value1: "",
      value2: "",
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //1.选择语言
    selectl(value) {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "post",
        datatype: "json",
        data: {
          act: "save_biaoshi",
          lang: value,
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.value1 = value;

            //绑定地区
            if (value == 0) {
              //简体
              that.options2 = [];
              var linshi = {
                value: "0",
                label: "中国",
              };
              that.options2.push(linshi);
            } else if (value == 6) {
              //繁体
              that.options2 = [];
              var linshi = {
                value: "0",
                label: "中國",
              };
              that.options2.push(linshi);
            } else if (value == 1) {
              //英文
              that.options2 = [];
              var linshi = [];
              linshi = {
                value: "1",
                label: "Europe",
                // disabled:true
              };
              that.options2.push(linshi);
              linshi = {
                value: "2",
                label: "North America",
                // disabled:true
              };
              that.options2.push(linshi);
              linshi = {
                value: "3",
                label: "Worldwide",
              };
              that.options2.push(linshi);
            }

            that.tiaozhuan();
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
    //2.选择区域
    selectr(value) {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "post",
        datatype: "json",
        data: {
          act: "save_region",
          region: value,
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.value2 = value;
            that.tiaozhuan();
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
    //3.两个都选了就跳转
    tiaozhuan() {
      if (this.value1 != "" && this.value2 != "") {
        location.href = "/dist/#/index";
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss' scoped>
@import "../../scss/public.scss";
.login {
  width: 100%;
  height: 100vh;
  background: url("../assets/loginBg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .login-main {
    width: $main-width;
    text-align: center;
    margin: 0 auto;
    padding-top: 200px;
    img {
      width: 530px;
      height: auto;
    }
    h1 {
      font-size: 3rem;
      color: #0069B5;
      font-weight: 600;
      letter-spacing: 0.2rem;
      margin-top: 70px;
    }
    .select-box {
      margin-top: 70px;
      .el-select {
        width: 430px;
        height: 70px;
        border-radius: 5px;
      }
    }
    .select-box >>> .el-input__inner {
      height: 70px;
      font-size: 1.5rem;
      font-family: 'kunbo' !important;
    }
    .select-box >>> .el-input__inner::-webkit-input-placeholder {
      color: #2d2d2d;
    }
    .subtn {
      margin: 100px auto;
      width: 296px;
      padding: 10px 0;
      background: #f8ad17;
      border-radius: 10px;
      display: flex;
      justify-content: center;
      a {
        font-size: 2rem;
        color: $text-color;
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  .login {
    .login-main {
      width: 100%;
      padding: 0 10px;
      img {
        width: 100%;
      }
      h1 {
        font-size: 2.6rem;
      }
      .select-box {
        margin-top: 70px;
        .el-select {
          width: 100%;
          margin-top: 20px;
          height: 70px;
          border-radius: 5px;
        }
      }
      .select-box >>> .el-scrollbar {
        height: auto;
      }
      .subtn {
        margin-top: 40px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue